import CloseIcon from "../../../assets/img/closeIcon.svg";
import Cancelimg from "../../../assets/img/cancel-01.svg";
import useTranslator from "../../../hooks/useTranslator";
import { Link } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { haveValue, toast } from "../../../helper/common";
import LandLordContext from "../../../context/landlord/LandLordContext";
import TenantContext from "../../../context/tenant/TenantContext";
import AuthContext from "../../../context/auth/AuthContext";
import UserIcon from "../../../assets/img/user-icon.svg";
import { Icon, TextField } from "../../../components/design";

const AddAgentModal = (props) => {
  const { _t } = useTranslator();
  const [searchText, setSearchText] = useState("");

  const { getAgencyAgents, alreadySharedSubLL } = useContext(LandLordContext);
  const { shareProfile, removeSharedProfile } = useContext(TenantContext);
  const { setLoading } = useContext(AuthContext);
  const {
    tenant_id = null,
    openModal = false,
    handleCloseModal = () => {},
  } = props;

  const [landlordListing, setLandlordListing] = useState([]);
  const [alreadySharedListingArr, setAlreadySharedListingArr] = useState([]);
  const [alreadySharedListing, setAlreadySharedListing] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    setLoading(true);
    getAgencyAgents()
      .then((res) => {
        const agentList = res?.data?.data;
        if (haveValue(agentList)) {
          setLandlordListing(agentList);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err, "Error inside getAgencyAgents");
      });
    alreadySharedSubLL(tenant_id)
      .then((res) => {
        const agentList = res?.data?.data;
        if (haveValue(agentList)) {
          const temp_list = agentList.map((agent) => agent?.landlord_info?._id);
          //   setAlreadySharedListing(agentList);
          setAlreadySharedListing(agentList);
          setAlreadySharedListingArr(temp_list);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err, "alreadySharedSubLL err");
      });
  };

  const handleShareProfile = async (tenant_id, landlord_id) => {
    shareProfile(tenant_id, landlord_id, "null", "full", {
      shareType: "parent_landlord",
      sendEmail: false,
    })
      .then((res) => {
        fetchData();
        toast.success(
          _t(
            "profileSharedSuccessfull",
            "Success popup when parent ll share a tenant profile with sub ll"
          )
        );
      })
      .catch((err) => {
        toast.error(
          _t(
            "errorWhileSharingProfile",
            "Error popup to show error while sharing profile"
          )
        );
      });
  };

  const handleUnShareProfile = async (landlord_id) => {
    const sharedProfile = alreadySharedListing.filter(
      (profile) => profile?.landlord_info?._id == landlord_id
    );
    const sharedProfileId = sharedProfile[0]?._id;

    if (haveValue(sharedProfileId)) {
      removeSharedProfile(sharedProfileId)
        .then((res) => {
          fetchData();
          toast.success(_t("profileUnshared"));
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const getName = () => {
    if (haveValue(searchText)) {
      return (landlordListing ?? []).filter((item) =>
        `${item?.fname_companyName} ${item?.lname}`
          ?.toLowerCase()
          .includes(searchText?.toLowerCase())
      );
    } else {
      return (landlordListing ?? []).filter((landlord) =>
        alreadySharedListingArr?.includes(landlord._id)
      );
    }
  };

  return (
    openModal && (
      <div className="wrapper-modal" onClick={handleCloseModal}>
        <div
          className={`doc-history-popup total-salary-modal share-profile-modal ${
            openModal ? "open" : ""
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          <span className="drawerIcon" onClick={handleCloseModal} />
          <div>
            <div className="doc-history-header">
              <div className="d-flex align-items-center custom-gap-2">
                <img
                  src={CloseIcon}
                  alt=""
                  className="doc-history-close-btn"
                  onClick={handleCloseModal}
                />
                <h4 className="custom-modal-heading">
                  {_t("sharedWithAgents")}
                </h4>
              </div>
            </div>
          </div>
          <div className="listWrapper">
            <div className="tabs-box-pattern">
              <div className="tabs-item d-block">
                <div className="profile-page marless tab-profile-search-header">
                  <div className="Search-bar searchbar_cls">
                    <div className="search_bar_edit">
                      <TextField
                        id="agent-search"
                        type="text"
                        size="sm"
                        icon={<Icon name="search" size={18} />}
                        placeholder={_t("searchLandlordAgent")}
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                      />
                      {haveValue(searchText) && (
                        <img
                          src={Cancelimg}
                          alt="icon"
                          className="canceicon topRightIcon searchCrossIcon"
                          onClick={() => setSearchText("")}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="tab-content" id="pills-tabContent">
                  <div
                    className="tab-pane fade show active"
                    id="pills-profile"
                    role="tabpanel"
                    aria-labelledby="pills-profile-tab"
                  >
                    <div className="edit-profile">
                      <div
                        className="tab-pane fade show active"
                        id="pills-home"
                        role="tabpanel"
                        aria-labelledby="pills-home-tab"
                      >
                        <div className="edit-profile">
                          <div className="Shortlisted-Properties"></div>
                          <div className="shareProfileHeader d-flex align-items-center custom-gap-2 justify-content-between">
                            <h4 className="sharedWithText">
                              {haveValue(searchText)
                                ? _t("searchResult")
                                : _t("sharedWith")}
                            </h4>
                          </div>
                          <div className="Notifications-row">
                            {haveValue(getName()) &&
                            Array.isArray(getName()) &&
                            getName().length > 0 ? (
                              getName()?.map((ll_detail) => {
                                return (
                                  <div
                                    className="Notifications-wapper opacity-wapper px-0 tt"
                                    key={ll_detail?._id}
                                  >
                                    <div className="mobile-profile-info-box">
                                      <div className="userImageWrapper">
                                        <img src={UserIcon} />
                                      </div>
                                      <div className="userDetails">
                                        <h4>
                                          {ll_detail?.fname_companyName}{" "}
                                          {ll_detail.lname}
                                        </h4>
                                      </div>
                                    </div>

                                    <div className="share-it">
                                      {alreadySharedListingArr.includes(
                                        ll_detail?._id
                                      ) ? (
                                        <Link
                                          className="share-btn"
                                          onClick={() =>
                                            handleUnShareProfile(ll_detail?._id)
                                          }
                                        >
                                          {_t("unShare")}
                                        </Link>
                                      ) : (
                                        <Link
                                          onClick={() =>
                                            handleShareProfile(
                                              tenant_id,
                                              ll_detail?._id
                                            )
                                          }
                                        >
                                          <img src="/images/share-icon.svg" />
                                          {_t("share")}
                                        </Link>
                                      )}
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <p className="notSharedText text-center">
                                {haveValue(searchText)
                                  ? _t("noDataFound")
                                  : _t("youHavetSharedThisProfileWithAgentYet")}
                              </p>
                            )}
                            {Array.isArray(landlordListing) &&
                              landlordListing?.length === 0 && (
                                <p className="notSharedText text-center">
                                  {_t("profileIsNotSharedWithAnyone")}
                                </p>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default AddAgentModal;
